import { FC } from 'react'
import cn from 'classnames'
import { FeedBadge } from 'interfaces/feed'
import { Verified } from 'components/features/socialFeed/FeedPost/Verified'
import styles from 'components/features/socialFeed/FeedUserInfo/FeedUserInfo.styl'
import { PremiumBadge } from 'components/features/pfm/PremiumBadge/PremiumBadge'

type FeedUserBadgeProps = {
  badge: FeedBadge
  mode: 'contrast' | 'default'
  className?: string
}

export const FeedUserBadge: FC<FeedUserBadgeProps> = (props) => {
  const { badge, mode, className } = props

  if (badge.slug === 'premium') {
    return (
      <div className={ cn(styles.premium, className) }>
        <PremiumBadge />
      </div>
    )
  }

  if (badge.slug === 'verified') {
    return (
      <Verified className={ cn(styles.verified, className) } />
    )
  }

  if (badge.slug === '1000+likes') {
    return (
      <div className={ cn(styles.likesBadge, className) }>
        1,000+
        { ' ' }
        <span className={ styles.hideOnTinyScreens }>likes</span>
      </div>
    )
  }

  return (
    <div className={ cn(styles.textBadge, mode === 'contrast' && styles.isContrast, className) }>
      { badge.text }
    </div>
  )
}
